import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const BusinessConsulting = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2070&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'Strategic Growth',
      description: 'Develop comprehensive strategies that drive sustainable business growth and competitive advantage.'
    },
    {
      title: 'Expert Guidance',
      description: 'Access to experienced consultants who understand your industry and business challenges.'
    },
    {
      title: 'Increased Efficiency',
      description: 'Identify and eliminate inefficiencies to optimize your business operations and reduce costs.'
    },
    {
      title: 'Risk Mitigation',
      description: 'Proactive identification and management of potential business risks and opportunities.'
    }
  ];

  const features = [
    'Business strategy development and implementation',
    'Market entry and expansion planning',
    'Organizational structure optimization',
    'Change management and transformation',
    'Performance improvement initiatives',
    'Competitive analysis and positioning',
    'Business model innovation',
    'Digital transformation strategies'
  ];

  const process = [
    {
      title: 'Discovery & Analysis',
      description: 'We begin by thoroughly understanding your business, challenges, goals, and current market position through comprehensive analysis.'
    },
    {
      title: 'Strategy Development',
      description: 'Our team develops customized strategies and actionable recommendations tailored to your specific business needs.'
    },
    {
      title: 'Implementation Planning',
      description: 'We create detailed implementation plans with clear milestones, responsibilities, and timelines for success.'
    },
    {
      title: 'Execution Support',
      description: 'Our consultants work alongside your team to ensure smooth execution and achievement of desired outcomes.'
    },
    {
      title: 'Monitoring & Optimization',
      description: 'Continuous monitoring and adjustment of strategies to ensure sustained success and optimal results.'
    }
  ];

  return (
    <ServiceTemplate
      icon="💼"
      title="Business Consulting"
      subtitle="Strategic guidance to transform your business and achieve sustainable growth"
      description="Our business consulting services provide expert strategic guidance to help your organization navigate complex challenges, seize opportunities, and achieve sustainable growth. With years of experience across various industries, we bring proven methodologies and fresh perspectives to drive your business forward."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Ready to transform your business? Contact us today to schedule a consultation and discover how our strategic guidance can help you achieve your goals."
    />
  );
};

export default BusinessConsulting;

